module.exports = ":host::ng-deep router-outlet + * {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main